










import { Component, Prop, Vue } from "vue-property-decorator";
import { IImage } from "@/store/types";

@Component
export default class USquareImage extends Vue {
  // Props
  @Prop({ default: null })
  public src!: IImage["full_url"];

  @Prop({ default: null })
  public alt!: string;

  @Prop({ default: null })
  public backgroundColor!: string;

  public get styles() {
    const styles = {};
    if (this.backgroundColor)
      styles["--background-color"] = this.backgroundColor;
    return styles;
  }
}
